import * as React from "react";
const SvgFiRrPodcast = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-podcast_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 4.071-2.039 7.831-5.453 10.059a.997.997 0 0 1-1.383-.292 1 1 0 0 1 .291-1.384A9.98 9.98 0 0 0 22.001 12c0-5.514-4.486-10-10-10S2 6.486 2 12a9.98 9.98 0 0 0 4.546 8.383 1 1 0 0 1-1.093 1.676A11.98 11.98 0 0 1 0 12C0 5.383 5.383 0 12 0s12 5.383 12 12m-6.167 3.871A6.96 6.96 0 0 0 19 12c0-3.859-3.14-7-7-7s-7 3.141-7 7c0 1.336.402 2.657 1.163 3.822a1.001 1.001 0 0 0 1.675-1.094 5 5 0 0 1-.837-2.729c0-2.757 2.243-5 5-5s5 2.243 5 5c0 .988-.288 1.944-.833 2.764a1 1 0 0 0 1.665 1.108m-3.416 1.031c.492.559.691 1.327.578 2.224l-.541 2.865c-.257 1.172-1.23 1.978-2.385 2.008h-.111a2.495 2.495 0 0 1-2.38-1.979l-.536-2.834c-.124-.956.076-1.725.568-2.283.528-.599 1.333-.902 2.392-.902 1.083 0 1.888.304 2.416.902zm-1.5 1.322c-.126-.143-.451-.225-.891-.225-.465 0-.79.082-.916.225-.098.111-.132.348-.094.649l.521 2.746a.5.5 0 0 0 .476.38.51.51 0 0 0 .482-.409l.525-2.776c.029-.242-.004-.479-.103-.59m1.084-6.225a2 2 0 1 0-3.999-.001 2 2 0 0 0 3.999.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-podcast_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPodcast;
